"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Topic_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Topic = void 0;
const dcterms_1 = require("lincd-dcmi/lib/ontologies/dcterms");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const titan_ads_1 = require("../ontologies/titan-ads");
const package_1 = require("../package");
let Topic = Topic_1 = class Topic extends Shape_1.Shape {
    static loadAll() {
        return Server_1.Server.call(package_1.packageName, 'loadAll', Topic_1.shape.namedNode);
    }
    static fromQuoraResponse(topicData) {
        var _a;
        const uri = process.env.DATA_ROOT + '/' + encodeURIComponent(topicData.tid);
        let topic;
        if (models_1.NamedNode.getNamedNode(uri) && !((_a = models_1.NamedNode.getNamedNode(uri)) === null || _a === void 0 ? void 0 : _a.isTemporaryNode)) {
            topic = new Topic_1(models_1.NamedNode.getNamedNode(uri));
            //for existing topics, we still set the properties based on data, because this currently happens on the frontend. But we dont want it to send any data updates, so we make manual quads
            //the whole topic setup is a bit custom, so we have to do it like this
            new models_1.Quad(topic.namedNode, dcterms_1.dcterms.title, new models_1.Literal(topicData.name), undefined, false, false);
            new models_1.Quad(topic.namedNode, dcterms_1.dcterms.identifier, new models_1.Literal(topicData.tid.toString(), xsd_1.xsd.integer), undefined, false, false);
        }
        else {
            topic = new Topic_1();
            topic.name = topicData.name;
            topic.id = topicData.tid;
        }
        return topic;
    }
    toPermanentTopicFrontend() {
        return Server_1.Server.call(package_1.packageName, 'toPermanentTopic', this);
    }
    toPermanentTopic() {
        //since we are using temporary URIs for topics, we have to set a unique URI based on its properties
        //before saving
        const uri = process.env.DATA_ROOT + '/' + encodeURIComponent(this.id);
        if (this.namedNode.uri !== uri) {
            //if it already exists, we don't need to save it again
            let existing = models_1.NamedNode.getNamedNode(uri);
            if (existing) {
                console.log('Topic already saved');
                return Promise.resolve(new Topic_1(existing));
            }
            //if it didnt, we can safely change the URI
            this.namedNode.uri = uri;
            return super.save().then(() => {
                return this;
            });
        }
        return null;
    }
    get id() {
        return this.hasProperty(dcterms_1.dcterms.identifier) ? Number.parseInt(this.getValue(dcterms_1.dcterms.identifier)) : undefined;
    }
    set id(val) {
        this.overwrite(dcterms_1.dcterms.identifier, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get name() {
        return this.getValue(dcterms_1.dcterms.title);
    }
    set name(val) {
        this.overwrite(dcterms_1.dcterms.title, new models_1.Literal(val));
    }
};
exports.Topic = Topic;
Topic.targetClass = titan_ads_1.titanAds.Topic;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dcterms_1.dcterms.identifier,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Topic.prototype, "id", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dcterms_1.dcterms.title,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Topic.prototype, "name", null);
exports.Topic = Topic = Topic_1 = __decorate([
    package_1.linkedShape
], Topic);
//# sourceMappingURL=Topic.js.map